<section class="home-card meetings" aria-labelledby="home-meetings-title">
  <div class="home-card__header">
    <h2 id="home-meetings-title" class="home-card__title">Reuniões</h2>
    <!-- "Agendar" do protótipo fica pendente: não há fluxo de agendamento (a tela Meetings só
         adiciona o bot numa call). Volta quando o agendamento existir (crítica G1). -->
  </div>

  @if (!companyId()) {
    <div class="home-card__empty">
      <i class="pi pi-building"></i>
      <span>Escolha uma única empresa no seletor do topo para ver as reuniões.</span>
    </div>
  } @else if (loading()) {
    <div class="meetings__loading" role="status" aria-label="Carregando as reuniões">
      <span class="home-skeleton meetings__skeleton-label"></span>
      <span class="home-skeleton meetings__skeleton-next"></span>
      <span class="home-skeleton meetings__skeleton-label"></span>
      @for (item of [0, 1, 2]; track item) {
        <span class="meetings__skeleton-row">
          <span class="home-skeleton meetings__skeleton-title"></span>
          <span class="home-skeleton meetings__skeleton-meta"></span>
        </span>
      }
    </div>
  } @else if (failed()) {
    <div class="home-card__error" role="alert">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Não foi possível carregar as reuniões agora.</span>
      <app-button
        label="Tentar de novo"
        theme="white"
        size="small"
        [noMargin]="true"
        (sendClick)="retry()"></app-button>
    </div>
  } @else if (isEmpty()) {
    <div class="home-card__empty meetings__empty">
      <i class="pi pi-calendar"></i>
      <span class="meetings__empty-text">
        <span>
          Ainda não há reuniões com a Legatus para esta empresa. Quando uma reunião for gravada, o
          resumo e as decisões aparecem aqui.
        </span>
        @if (canOpenMeetings()) {
          <a class="home-card__link meetings__empty-link" [routerLink]="meetingsRoute">
            Adicionar o bot numa reunião
            <i class="pi pi-arrow-right"></i>
          </a>
        }
      </span>
    </div>
  } @else {
    <p class="home-section-label">Próxima</p>
    @if (next(); as next) {
      <div class="meetings__next">
        <div class="meetings__date-badge" aria-hidden="true">
          <span class="meetings__date-month">{{ next.month }}</span>
          <span class="meetings__date-day">{{ next.day }}</span>
        </div>
        <div class="meetings__next-body">
          <p
            class="meetings__title"
            [pTooltip]="next.title"
            tooltipPosition="top"
            [showDelay]="400">
            {{ next.title }}
          </p>
          <p class="meetings__meta">
            @if (next.relativeDay) {
              <span class="meetings__relative">{{ next.relativeDay }}</span>
            }
            <span class="meetings__meta-text">{{ next.meta }}</span>
          </p>
        </div>
        @if (next.meetingUrl) {
          <a
            class="meetings__icon-link"
            target="_blank"
            rel="noopener noreferrer"
            pTooltip="Entrar na reunião"
            tooltipPosition="top"
            aria-label="Entrar na reunião"
            [href]="next.meetingUrl">
            <i class="pi pi-video"></i>
          </a>
        }
      </div>
    } @else {
      <p class="meetings__empty-line">Nenhuma reunião agendada com a Legatus.</p>
    }

    <p class="home-section-label">Recentes</p>
    @if (recent().length) {
      <ul class="meetings__list">
        @for (meeting of recent(); track meeting.id) {
          <li class="meetings__item" [class.meetings__item--open]="expandedId() === meeting.id">
            <div class="meetings__item-row">
              <button
                type="button"
                class="meetings__toggle"
                [attr.aria-expanded]="expandedId() === meeting.id"
                [attr.aria-controls]="'home-meeting-panel-' + meeting.id"
                (click)="toggle(meeting.id)">
                <i
                  class="pi pi-chevron-down meetings__chevron"
                  [class.meetings__chevron--open]="expandedId() === meeting.id"></i>
                <span class="meetings__item-text">
                  <span
                    class="meetings__item-title"
                    [pTooltip]="meeting.title"
                    tooltipPosition="top"
                    [showDelay]="400"
                    >{{ meeting.title }}</span
                  >
                  <span class="meetings__meta">{{ meeting.meta }}</span>
                </span>
              </button>
              @if (canOpenMeetings()) {
                <a
                  class="meetings__icon-link"
                  pTooltip="Abrir reunião"
                  tooltipPosition="top"
                  aria-label="Abrir reunião"
                  [routerLink]="['/dashboard/meetings', meeting.id]">
                  <i class="pi pi-external-link"></i>
                </a>
              }
            </div>
            @if (expandedId() === meeting.id) {
              <div class="meetings__panel" [id]="'home-meeting-panel-' + meeting.id">
                @if (meeting.hasInsights) {
                  @if (meeting.summary) {
                    <p
                      class="meetings__panel-line meetings__panel-line--clamp"
                      [pTooltip]="meeting.summary"
                      tooltipPosition="top"
                      [showDelay]="400">
                      <b>Resumo:</b> {{ meeting.summary }}
                    </p>
                  }
                  <ng-container
                    *ngTemplateOutlet="
                      panelList;
                      context: { $implicit: meeting.decisions, label: 'Decisões', meeting: meeting }
                    "></ng-container>
                  <ng-container
                    *ngTemplateOutlet="
                      panelList;
                      context: {
                        $implicit: meeting.nextSteps,
                        label: 'Próximos passos',
                        meeting: meeting,
                      }
                    "></ng-container>
                } @else {
                  <p class="meetings__panel-line">O resumo desta reunião ainda não está pronto.</p>
                }
              </div>
            }
          </li>
        }
      </ul>
    } @else {
      <p class="meetings__empty-line">Nenhuma reunião concluída com a Legatus ainda.</p>
    }
  }

  <!-- Bloco do painel (protótipo `_reunioes`): um item fica na linha do rótulo; mais de um vira lista curta de até 3,
       com "+ N" que leva à reunião (time interno) ou mostra o resto no lugar (cliente). Crítica 3819, G2 e G4. -->
  <ng-template #panelList let-list let-label="label" let-meeting="meeting">
    @if (list.all.length === 1) {
      <p
        class="meetings__panel-line meetings__panel-line--clamp"
        [pTooltip]="list.all[0]"
        tooltipPosition="top"
        [showDelay]="400">
        <b>{{ label }}:</b> {{ list.all[0] }}
      </p>
    } @else if (list.all.length > 1) {
      <div class="meetings__panel-block">
        <b>{{ label }}:</b>
        <ul class="meetings__panel-list">
          @for (entry of fullListsId() === meeting.id ? list.all : list.visible; track $index) {
            <li>
              <span
                class="meetings__panel-entry"
                [pTooltip]="entry"
                tooltipPosition="top"
                [showDelay]="400"
                >{{ entry }}</span
              >
            </li>
          }
        </ul>
        @if (list.hiddenLabel && fullListsId() !== meeting.id) {
          @if (canOpenMeetings()) {
            <a class="meetings__more" [routerLink]="['/dashboard/meetings', meeting.id]">{{
              list.hiddenLabel
            }}</a>
          } @else {
            <button type="button" class="meetings__more" (click)="showFullLists(meeting.id)">
              {{ list.hiddenLabel }}
            </button>
          }
        }
      </div>
    }
  </ng-template>

  @if (canOpenMeetings()) {
    <div class="home-card__footer">
      <a class="home-card__link" [routerLink]="meetingsRoute">
        Ver Todas as Reuniões
        <i class="pi pi-arrow-right"></i>
      </a>
    </div>
  }
</section>
